const login = {
  login: 'Войти',
  phone: 'Телефон',
  email: 'Электронная почта',
  erCode: 'QR-код',
  phoneNo: 'Номер телефона',
  sryx: 'Введите адрес электронной почты',
  password: 'Пароль',
  wjmm: 'Забыли пароль?',
  srmm: 'Введите пароль',
  myzh: 'Нет аккаунта?',
  ljzc: 'Зарегистрироваться',
  cxsm: 'Обновите страницу и отсканируйте QR-код заново в приложении Biking',
  xydl: 'Пожалуйста, подтвердите вход на мобильном устройстве',
  smewm: 'В приложении Biking нажмите на иконку профиля, затем на иконку в правом верхнем углу, чтобы отсканировать QR-код',
  qtfs: 'Другие способы входа',
  ggsfyz: 'Google Authenticator',
  bdsj: 'Вы привязали номер телефона',
  bdyx: 'Вы привязали электронную почту',
  fsyzm: 'Отправить код подтверждения',
  wcyz: 'Пожалуйста, завершите проверку',
  dlcg: 'Вы успешно вошли в систему! Biking приветствует вас!',
  bktb: 'В целях безопасности вывод средств недоступен в течение 24 часов после изменения настроек безопасности аккаунта.',
  fhdl: 'Вернуться на страницу входа',
  jx: 'Продолжить',
  cxfs: 'Отправить повторно',
  gxmm: 'Обновить пароль',
  srsjh: 'Введите номер телефона',
  wjmm1: 'Забыли пароль',
  sryxdz: 'Введите адрес электронной почты',
  srzqyx: 'Введите корректный адрес электронной почты',
  sryzm: 'Введите код подтверждения',
  czmm: 'Сбросить пароль',
  sbdyzm: 'Не получили код?',
  srxmm: 'Введите новый пароль',
  zczh: 'Зарегистрировать аккаунт Biking',
  yqm: 'Реферальный код (необязательно)',
  sryqm: 'Введите реферальный код',
  zc: 'Зарегистрироваться',
  yyzh: 'Уже есть аккаунт?',
  ljdl: 'Войти сейчас',
  fsz: 'Код подтверждения отправлен на',
  next: 'Далее',
  szmm: 'Установить пароль',
  submit: 'Отправить',
  zccg: 'Регистрация успешна!'
}

const download = {
  title: 'Многофункциональная игровая платформа<br/>и платформа для торговли цифровыми валютами',
  subTitle: 'BiKing позволяет торговать более чем сотней цифровых валют',
  xzbw: 'Почему стоит выбрать BiKing',
  czzz: 'BiKing помогает вам создавать, приумножать и защищать ваше богатство',
  download: 'Скачать из App Store',
  downloadtf: 'Скачать через TestFlight',
  cjqxz: 'Скачать через Super Signature',
  cjq: 'Super Signature {index}',
  bdxz: 'Локальная загрузка',
  ggpxz: 'Скачать из Google Play',
  advantageTitle1: 'Высокая производительность · Мгновенные сделки',
  subTitleSubTitle1: 'Технология Лондонской фондовой биржи, сверхнизкая задержка, быстрое сопоставление ордеров',
  advantageTitle2: 'Безопасность активов · Максимальная защита',
  subTitleSubTitle2: 'BiKing соответствует стандарту CCSS, гарантируя безопасность активов и данных',
  advantageTitle3: 'Круглосуточная поддержка',
  subTitleSubTitle3: 'Обеспечение бесперебойной работы системы и предоставление круглосуточной клиентской поддержки',
  qhidxq: 'Инструкция по смене Apple ID',
  step1: 'Шаг 1',
  step2: 'Шаг 2',
  step3: 'Шаг 3',
  step4: 'Шаг 4',
  step5: 'Шаг 5',
  step6: 'Шаг 6',
  step7: 'Шаг 7',
  step8: 'Шаг 8',
  step9: 'Шаг 9',
  step10: 'Шаг 10',
  azBiking: 'Установка BiKing через App Store',
  dlxz: 'Если у вас есть Apple ID не для континентального Китая, просто войдите в App Store и скачайте приложение.',
  fdlid: 'Подготовьте Apple ID не для континентального Китая',
  yxfshq: 'Если у вас нет Apple ID не для континентального Китая, вы можете попробовать получить его следующими способами',
  qhid: 'Сменить Apple ID в App Store',
  dk: '1. Откройте',
  ysjtx: 'App Store, нажмите на аватар в правом верхнем углу',
  cxsrmm: '2. Нажмите «Выйти», затем введите Apple ID и пароль заново',
  wfdl: '* Если появляется сообщение «Не удаётся войти», возможно, вы слишком часто меняли аккаунт. Попробуйте сменить ID или повторите попытку через несколько часов. Если ID заблокирован, потребуется его верификация или смена ID.',
  azapp: 'Установка приложения',
  storesh: '1. После успешного входа вы автоматически попадёте в App Store соответствующего региона. Найдите в поиске «BiKing», нажмите кнопку «Get» и начните установку.',
  jxxz: 'У меня есть некитайский Apple ID, продолжить загрузку',
  jxxz1: 'Продолжить загрузку',
  way1: 'Способ 1',
  wayTitle1: 'Зарегистрируйтесь самостоятельно — безопасно и надёжно',
  wayBtn1: 'Узнать, как зарегистрироваться',
  way2: 'Способ 2',
  wayTitle2: 'Рекомендуемые ID от платформы (быстро и удобно)',
  wayBtn2: 'Посмотреть рекомендуемые ID',
  way3: 'Способ 3',
  wayTitle3: 'Выбор страны/региона (свободное переключение)',
  wayBtn3: 'Узнать, как купить',

  ckzh: 'Рекомендуемые Apple ID не для континентального Китая',
  jgck: 'Используйте следующие зарубежные ID для справки',
  jjfz: '(нажмите на аккаунт или пароль для прямого копирования)',
  zh: 'Аккаунт',
  mm: 'Пароль',
  xxxl: 'Чтобы предотвратить утечку ваших данных',
  dlicloud: 'НЕ используйте указанные выше Apple ID для входа в iCloud.',
  tczh: 'После загрузки приложения с помощью рекомендуемого Apple ID обязательно выйдите из этого аккаунта.',
  cfsy: 'Не привязывайте номер телефона, иначе ID станет непригодным для повторного использования.',
  jrql: 'Отсканируйте QR-код, чтобы присоединиться к чату',
  lxkf: 'Связаться с поддержкой',

  zjzc: 'Как самостоятельно зарегистрировать зарубежный Apple ID',
  registerStep1: 'Шаг 1: Откройте appleid.apple.com',
  registerStep2: 'Шаг 2: Подтвердите электронную почту',
  registerStep3: 'Шаг 3: Выйдите из App Store',
  registerStep4: 'Шаг 4: Войдите в Store с только что зарегистрированным ID',
  gwzcwz: 'Откройте страницу регистрации Apple в браузере Safari: (appleid.apple.com)',
  yzdzyx: 'После заполнения всех данных нажмите «Продолжить». Вы получите письмо для подтверждения Apple ID — введите код из письма.',
  tjfkfs: 'Далее вы автоматически попадёте в раздел управления Apple ID. Зайдите в «Способы оплаты и доставка» и нажмите «Добавить способ оплаты».',
  mgsfzsc: 'Самый ответственный момент: убедитесь, что способ оплаты — «Нет». Если так, ничего не меняйте. Убедитесь, что выбраны США или желаемый регион. Остальные поля можно заполнить произвольно, лучше на английском. Выберите штат Аляска (нет налогов на покупки). Для генерации данных можно использовать сайты-генераторы американских удостоверений личности.',
  gxdqxx: 'После заполнения нажмите «Обновить», чтобы сохранить региональную информацию.',
  zhxx: '1. Зайдите в App Store, нажмите на аватар в правом верхнем углу',
  djwc: '2. Прокрутите страницу вниз, нажмите «Выйти», затем «Готово»',
  jrzhdl: '1. Снова нажмите на аватар в правом верхнем углу для входа',
  zhmmdl: '2. Введите ID и пароль, нажмите «Войти»',
  jydlcg: '3. Введите код подтверждения. После успешной проверки вы войдёте в Apple ID.',
  jysssd: 'Торгуйте где угодно и когда угодно',
  smewm: 'Отсканируйте QR-код',
  xiazai: 'Скачать',
  huodong: 'Акции',
  title1: 'Biking: многофункциональные игры',
  title2: 'и платформа для торговли цифровыми валютами',
  open: 'Открыть в приложении Biking',
  ggzx: 'Центр объявлений',
  lscb: 'Пополнение через сеть',
  fbrj: 'Фиатные деньги',
  tgaq: 'Мы стремимся обеспечить более безопасную',
  wdjmzc: 'и стабильную платформу для торговли крипто-деривативами.',
  szhbjy: 'Мы профессионалы в торговле цифровыми валютами',
  yxhsjh: 'Зарегистрируйтесь по адресу эл. почты / номеру телефона',

  appBetaTag: 'Официальный запуск BETA',
  appHeroTitle: 'Масштабное обновление приложения',
  appHeroSubtitle: 'Откройте новый маршрут для торговли на Biking',
  tryNow: 'Попробовать сейчас',
  downloadBikingApp: 'Скачать приложение Biking',
  roadmapStageMeta: '/{total} {phase}',
  roadmapPhase1: 'Этап 1',
  roadmapPhase2: 'Этап 2',
  roadmapPhase3: 'Этап 3',
  roadmapPhase4: 'Этап 4',
  roadmapPhase5: 'Этап 5',
  roadmapVisionTitle: 'Визуальное обновление',
  roadmapVisionDesc: 'Новый дизайн-язык · Продуманные взаимодействия · Иммерсивный интерфейс',
  roadmapVisionPoint1: 'Новый дизайн-язык',
  roadmapVisionPoint2: 'Продуманные взаимодействия',
  roadmapVisionPoint3: 'Иммерсивный интерфейс',
  roadmapEngineTitle: 'Апгрейд движка производительности',
  roadmapEngineDesc: 'Перестроенная архитектура ядра · Отклик в миллисекундах · Высокая стабильность',
  roadmapEnginePoint1: 'Перестроенная архитектура ядра',
  roadmapEnginePoint2: 'Отклик в миллисекундах',
  roadmapEnginePoint3: 'Высокая стабильность',
  roadmapBetaTitle: 'Запуск Beta',
  roadmapBetaDesc: 'Торговая система нового поколения · Сверхбыстрое сопоставление · Ограниченный доступ',
  roadmapBetaPoint1: 'Торговая система нового поколения',
  roadmapBetaPoint2: 'Сверхбыстрое сопоставление',
  roadmapBetaPoint3: 'Ограниченный доступ',
  roadmapGlobalTitle: 'Комплексная эволюция платформы',
  roadmapAiTitle: 'Эра AI-трейдинга',
  comingSoon: 'Скоро',
  appCopyright: '© 2016-2026 BiKing. Все права защищены.',
  testFlight: 'Test Flight',
  appStore: 'App Store',
  googlePlay: 'Google Play',
  superSign: 'Super Sign',
  chooseDownload: 'Выберите способ загрузки',
  downloadAddr1: 'Ссылка для загрузки 1',
  downloadAddr2: 'Ссылка для загрузки 2',
  downloadCancel: 'Отмена',
  apkLocalDownload: 'Скачать APK',
  entryBetaTitle: 'Версия Beta уже доступна',
  entryBetaSubtitle: 'Опробуйте новейшие функции первыми',
  entryBetaTitleFull: 'Версия Beta уже доступна — опробуйте новейшие функции первыми!',
  entryDownloadNow: 'Скачать сейчас',
  entryTagNew: 'New',
  entryClose: 'Закрыть',
}

export { login, download }


// WEBPACK FOOTER //
// ./src/i18n/lang/login/ru.js